var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  buildCommutativeExpression: () => buildCommutativeExpression,
  getNonCommutativeOperandExpression: () => getNonCommutativeOperandExpression,
  isCommutative: () => isCommutative
});
var import_mathFunctionError = __toModule(require("../../../../error/mathFunctionError"));
var import_utils = __toModule(require("./utils"));
const COMMUTATIVE_FUNCTIONS = [
  "addMatrices",
  "addMatrix",
  "concatenate",
  "empty",
  "equalMatrices",
  "equalTextMatrices",
  "largerEqMatrices",
  "largerMatrices",
  "maximum",
  "maximumMatrices",
  "maximumMatrix",
  "minimum",
  "minimumMatrices",
  "minimumMatrix",
  "multiplyMatrices",
  "multiplyMatrix",
  "smallerEqMatrices",
  "smallerMatrices",
  "summatoryMatrix",
  "unequalMatrices",
  "unequalTextMatrices"
];
const NON_COMMUTATIVE_FUNCTIONS_TRANSLATE = {
  divideMatrices: "multiplyMatrices",
  divideMatrix: "multiplyMatrix",
  subtractMatrices: "addMatrices",
  subtractMatrix: "addMatrix"
};
const NON_COMMUTATIVE_FUNCTIONS = Object.keys(NON_COMMUTATIVE_FUNCTIONS_TRANSLATE);
const ALL_FUNCTIONS = COMMUTATIVE_FUNCTIONS.concat(NON_COMMUTATIVE_FUNCTIONS);
const isCommutative = (functionName) => {
  return ALL_FUNCTIONS.includes(functionName);
};
const getNonCommutativeOperandExpression = (functionName, allOperands) => {
  return allOperands.length > 1 ? `${functionName}(${allOperands.join(", ")})` : allOperands;
};
const buildCommutativeExpression = (functionName, operands1, operands2) => {
  if (!isCommutative(functionName)) {
    throw new import_mathFunctionError.MathFunctionError(`Function ${functionName}. Not a commutative function`);
  }
  if (COMMUTATIVE_FUNCTIONS.includes(functionName)) {
    const operands = (0, import_utils.concatMultipleOperands)(operands1, operands2);
    return `${functionName}(${operands.join(", ")})`;
  }
  const allOperands1 = (0, import_utils.concatMultipleOperands)(operands1);
  const allOperands2 = (0, import_utils.concatMultipleOperands)(operands2);
  const translatedFunction = NON_COMMUTATIVE_FUNCTIONS_TRANSLATE[functionName];
  const operands1Expression = getNonCommutativeOperandExpression(translatedFunction, allOperands1);
  const operands2Expression = getNonCommutativeOperandExpression(translatedFunction, allOperands2);
  if (!operands2Expression) {
    return `${functionName}(${operands1Expression})`;
  }
  return `${functionName}(${operands1Expression}, ${operands2Expression})`;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  buildCommutativeExpression,
  getNonCommutativeOperandExpression,
  isCommutative
});
